import { Button, NumberInput, Paper, Stack, Title } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Sync } from '@/module/Sync/Sync';
import { useScopusImportResult } from '@/module/Sync/model/SyncQuery';
import { ImportResult } from '@/module/Sync/model/SyncTypes';

import { PendingSpinner } from '@/core/components';

import { useAppNotification } from '@feature/utils';

export function SyncScopus() {
  const { t } = useTranslation();
  const [result, setResult] = useState<ImportResult | null>(null);
  const [yearStr, setYearStr] = useState<string | number>('2023');

  const year = yearStr == null || yearStr === '' ? 2023 : Number(yearStr);

  const { mutate, isPending } = useScopusImportResult();
  const notification = useAppNotification();
  const onImport = () => {
    mutate(year, {
      onSuccess: setResult,
      onError: notification.error,
    });
  };

  if (isPending) {
    return <PendingSpinner />;
  }

  return (
    <Stack p="md">
      <Title>{t('sync.scopus.title')}</Title>

      {result == null && (
        <Paper p="md">
          <Stack>
            <NumberInput
              value={year}
              onChange={setYearStr}
              label={t('sync.scopus.year')}
              placeholder={t('sync.scopus.year')}
            />
            <Button onClick={onImport}>{t('button.import')}</Button>
          </Stack>
        </Paper>
      )}
      {result != null && (
        <Sync
          sourceType="SCOPUS"
          result={result}
        />
      )}
    </Stack>
  );
}
